module.exports = __webpack_public_path__ + "static/img/yuanmazhen_icon.7e9750ce.png";